import { Icon } from '@iconify/react/dist/iconify.js'
import './style.css'
import { translate } from '@/utils/langUtils'
const SectionWrapper = ({ name, icon, children }) =>
    <div className="broker-section row">
        <div className="broker-section-header col-12">
            <Icon icon={icon} width="24" height="24" />
            <h2 className="broker-section-title">{translate(name)}</h2>
        </div>
        {children}
    </div>

export default SectionWrapper